// Actions
export const SET_MENU_ACTIVE = 'setMenu';

// Mutations
export const STORE_SET_MENU = 'storeSetMenu';

const state = {
    menuActive: true
};

const getters = {
    isMenuActive(state) {
        return state.menuActive
    }
};

const actions = {
    [SET_MENU_ACTIVE](context, state) {
        context.commit(STORE_SET_MENU, state);
    }
};

const mutations = {
    [STORE_SET_MENU](state, status) {
        state.menuActive = status;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}